var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6667 60H13.3333C5.96667 60 0 54.0333 0 46.6667V13.3333C0 5.96667 5.96667 0 13.3333 0H46.6667C54.0333 0 60 5.96667 60 13.3333V46.6667C60 54.0333 54.0333 60 46.6667 60Z",
    fill: "#012063",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3332 31.5625H21.6665C20.8123 31.5625 20.104 30.8542 20.104 30C20.104 29.1458 20.8123 28.4375 21.6665 28.4375H38.3332C39.1873 28.4375 39.8957 29.1458 39.8957 30C39.8957 30.8542 39.1873 31.5625 38.3332 31.5625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 39.8957C29.1458 39.8957 28.4375 39.1873 28.4375 38.3332V21.6665C28.4375 20.8123 29.1458 20.104 30 20.104C30.8542 20.104 31.5625 20.8123 31.5625 21.6665V38.3332C31.5625 39.1873 30.8542 39.8957 30 39.8957Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2498 52.3957H23.7498C12.4373 52.3957 7.604 47.5623 7.604 36.2498V23.7498C7.604 12.4373 12.4373 7.604 23.7498 7.604H36.2498C47.5623 7.604 52.3957 12.4373 52.3957 23.7498V36.2498C52.3957 47.5623 47.5623 52.3957 36.2498 52.3957ZM23.7498 10.729C14.1457 10.729 10.729 14.1457 10.729 23.7498V36.2498C10.729 45.854 14.1457 49.2707 23.7498 49.2707H36.2498C45.854 49.2707 49.2707 45.854 49.2707 36.2498V23.7498C49.2707 14.1457 45.854 10.729 36.2498 10.729H23.7498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLogoIcon);
export default __webpack_public_path__ + "static/media/upload-logo-icon.7dfc7744204c96ab73bbff11d89fce3a.svg";
export { ForwardRef as ReactComponent };